import { render } from "./indicator-add-model.vue?vue&type=template&id=1151f7ec"
import script from "./indicator-add-model.vue?vue&type=script&lang=js"
export * from "./indicator-add-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__